import {createError} from '../services/errors';
import {buildFetch} from '../services/fetch';
import {i18n} from '../services/i18n';

import config from 'config';

export const START_LOADING_PRIVACY_AGREEMENT =
  'START_LOADING_PRIVACY_AGREEMENT';
export const PRIVACY_AGREEMENT_LOADING_SUCCESS =
  'PRIVACY_AGREEMENT_LOADING_SUCCESS';
export const PRIVACY_AGREEMENT_LOADING_ERROR =
  'PRIVACY_AGREEMENT_LOADING_ERROR';

const defaultPrivacyAgreement = i18n._(
  'privacy.default',
  {},
  {
    defaults:
      'Autorizzo il trattamento dei miei dati personali e della mia immagine (foto e/o video) ai sensi del D. LGS. 196/2003'
  }
);

// const defaultPrivacyAgreement =
//   'Autorizzo il trattamento dei miei dati personali e della mia immagine (foto e/o' +
//   ' video) ai sensi del D. LGS. 196/2003';

export function privacyAgreementLoadingSuccess(privacy) {
  return {
    type: PRIVACY_AGREEMENT_LOADING_SUCCESS,
    privacy: privacy || defaultPrivacyAgreement
  };
}

export const privacyAgreementLoadingError = createError(
  PRIVACY_AGREEMENT_LOADING_ERROR
);

export function loadPrivacyAgreement() {
  return dispatch => {
    dispatch({type: START_LOADING_PRIVACY_AGREEMENT});

    const fetch = buildFetch(dispatch);
    fetch(`${config.api}/auth/privacy/agreement`)
      .then(response => {
        if (response.data.status !== true) {
          throw new Error('Invalid privacy agreement');
        }

        dispatch(privacyAgreementLoadingSuccess(response.data.privacy));
      })
      .catch(error => {
        if (error) {
          dispatch(privacyAgreementLoadingError(error));
        }
      });
  };
}
